import { InkomstenBelastingRates } from './interface';

export const rates: InkomstenBelastingRates = {
    senior: {
        2018: [
            { to:  20_142, percentage: 18.65 },
            { to:  34_404, percentage: 22.95 },
            { to:  68_507, percentage: 40.85 },
            { percentage: 51.95 },
        ],
        2019: [
            { to: 20_711, percentage: 18.75 },
            { to: 34_712, percentage: 20.20 },
            { to: 68_507, percentage: 38.10 },
            { percentage: 51.75 }
        ],
        2020: [
            { to: 34_712, percentage: 19.45 },
            { to: 68_507, percentage: 37.35 },
            { percentage: 49.50 }
        ],
        2021: [
            { to: 34_712, percentage: 19.20 },
            { to: 68_507, percentage: 37.10 },
            { percentage: 49.5 }
        ],
        2022: [
            { to: 35_473, percentage: 19.17 },
            { to: 69_399, percentage: 37.07 },
            { percentage: 49.5 }
        ],
        2023: [
            { to: 38_703, percentage: 19.03 },
            { to: 73_031, percentage: 36.93 },
            { percentage: 49.5 }
        ]
    },
    nonSenior: {
        2018: [
            { to: 20_142, percentage: 36.55 },
            { to: 33_994, percentage: 40.85 },
            { to: 68_507, percentage: 40.85 },
            { percentage: 51.95 }
        ],
        2019: [
            { to: 20_384, percentage: 36.65 },
            { to: 34_300, percentage: 38.10 },
            { to: 68_507, percentage: 38.10 },
            { percentage: 51.75 },
        ],
        2020: [
            { to: 68_507, percentage: 37.35 },
            { percentage: 49.5 }    
        ],
        2021: [
            { to: 68_507, percentage: 37.1 },
            { percentage: 49.5 }
        ],
        2022: [
            { to: 69_398, percentage: 37.07 },
            { percentage: 49.5 }
        ],
        2023: [
            { to: 73_031, percentage: 36.93 },
            { percentage: 49.5 }
        ],
        2024: [
            { to: 75_518, percentage: 36.97 },
            { percentage: 49.5 }
        ]
    }
};